import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import Encryption from '../utils/encrypt';

const spinar = 'hymne-era';

@Injectable({
    providedIn : 'root'
})
export class EncryptionService {
    private crypt: Encryption;

    constructor(
        private toastr: ToastrService
    ) {
        this.crypt = new Encryption();
    }

    public getItem(item: string): any {
        try {
            const cryptedData = localStorage.getItem(item);
            const decrypted = JSON.parse(this.crypt.decrypt(cryptedData, spinar));
            return decrypted;
        } catch (error) {
            this.toastr.error('Error decrypting data');
            throw new Error('Crypt error.');
        }
    }

    public isItem(item: string): boolean {
        const auth = localStorage.getItem(item);
        if (auth !== 'undefined' && auth !== '' && auth != null) {
            return true;
        }
        return false;
    }

    public saveData(key: string, data: any): boolean {
        try {
            const stringify = JSON.stringify(data);
            const encrypted = this.crypt.encrypt(stringify, spinar);
            localStorage.setItem(key, encrypted);
            return true;
        } catch (error) {
            this.toastr.error('Error encrypting data');
            throw new Error('Crypt error.');
        }
    }
}
